import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { $TSFixMe } from 'types/ts-migrate'
import { portfolioApiEvents } from 'modules/api/portfolio'

type ChatbotPortfolioState = {
  currentPortfolioId: string | null
  savedDialogs: {
    [key: string]: $TSFixMe
  }
  activationConfirmationOpen: boolean
}

const initialState: ChatbotPortfolioState = {
  currentPortfolioId: null,
  savedDialogs: {},
  activationConfirmationOpen: false,
}

const NAMESPACE = 'chatbot/portfolio'

// Epic-trigger actions: no reducer logic, epics react to them
const portfolioRedirect = createAction<string>(`${NAMESPACE}/portfolioRedirect`)
const takeMeHome = createAction(`${NAMESPACE}/takeMeHome`)
const setGlobalVat = createAction<boolean>(`${NAMESPACE}/setGlobalVat`)
const newPortfolioRequested = createAction(`${NAMESPACE}/newPortfolioRequested`)
const loadPortfolioRequested = createAction<string>(`${NAMESPACE}/loadPortfolioRequested`)
const propertyConfirmationRequested = createAction<$TSFixMe>(`${NAMESPACE}/propertyConfirmationRequested`)
const termValuesSubmitted = createAction<$TSFixMe>(`${NAMESPACE}/termValuesSubmitted`)
const rentValuesSubmitted = createAction<$TSFixMe>(`${NAMESPACE}/rentValuesSubmitted`)
const settingsValuesSubmitted = createAction<$TSFixMe>(`${NAMESPACE}/settingsValuesSubmitted`)
const commissionValuesSubmitted = createAction<$TSFixMe>(`${NAMESPACE}/commissionValuesSubmitted`)
const invoiceValuesSubmitted = createAction<$TSFixMe>(`${NAMESPACE}/invoiceValuesSubmitted`)
const currentPortfolioActivationRequested = createAction(`${NAMESPACE}/currentPortfolioActivationRequested`)
const agencyDetailsSubmitted = createAction<$TSFixMe>(`${NAMESPACE}/agencyDetailsSubmitted`)
const brandingDetailsSubmitted = createAction<$TSFixMe>(`${NAMESPACE}/brandingDetailsSubmitted`)

const chatbotPortfolioSlice = createSlice({
  name: NAMESPACE,
  initialState,
  reducers: {
    setCurrentPortfolio: (state, { payload }: PayloadAction<$TSFixMe>) => {
      state.currentPortfolioId = payload.id
    },
    resetCurrentPortfolio: state => {
      state.currentPortfolioId = null
    },
    captureDialogState: (state, { payload }: PayloadAction<{ dialog: string; dialogState: $TSFixMe }>) => {
      state.savedDialogs[payload.dialog] = payload.dialogState
    },
    currentPortfolioActivationConfirmationTriggered: state => {
      state.activationConfirmationOpen = true
    },
    currentPortfolioActivationDeclined: state => {
      state.activationConfirmationOpen = false
    },
  },
  extraReducers: builder => {
    builder.addCase(portfolioApiEvents.approve_request, state => {
      state.activationConfirmationOpen = false
    })
  },
})

const { reducer } = chatbotPortfolioSlice

const events = {
  ...chatbotPortfolioSlice.actions,
  portfolioRedirect,
  takeMeHome,
  setGlobalVat,
  newPortfolioRequested,
  loadPortfolioRequested,
  propertyConfirmationRequested,
  termValuesSubmitted,
  rentValuesSubmitted,
  settingsValuesSubmitted,
  commissionValuesSubmitted,
  invoiceValuesSubmitted,
  currentPortfolioActivationRequested,
  agencyDetailsSubmitted,
  brandingDetailsSubmitted,
}

export { events, reducer }
export { events as chatbotEvents }
